import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M0 16 16 0l16 16-2.1 2.1L17.5 5.7V32h-3V5.7L2.1 18.1z" }, null, -1)
  ]));
}
const ArrowUp = { render };
export {
  ArrowUp as default,
  render
};
//# sourceMappingURL=ArrowUp.svg.js.map
